import { subscriptionPlanAdminClient } from '@/helpers/api/apiClients'
import {
	SearchSubscriptionPlansRequest,
	type ISearchSubscriptionPlansRequest,
	CreateSubscriptionPlanAdminRequest,
	type ICreateSubscriptionPlanAdminRequest,
	SubscriptionPlanPaymentCycleTypes,
	UpdateSubscriptionPlanAdminRequest,
	type IUpdateSubscriptionPlanAdminRequest,
	SubscriptionPlanFeatureItemRequest,
} from '@/helpers/api/WebApiClient'

interface FeatureItemInput {
	id?: number
	featureText: string
	sortOrder: number
}

const toFeatureInstances = (features?: FeatureItemInput[]) => features?.map((f) => new SubscriptionPlanFeatureItemRequest(f))

type CreatePlanInput = Omit<ICreateSubscriptionPlanAdminRequest, 'features'> & { features?: FeatureItemInput[] }
type UpdatePlanInput = Omit<IUpdateSubscriptionPlanAdminRequest, 'features'> & { features?: FeatureItemInput[] }

export const subscriptionPlanAdminService = {
	search: (request: ISearchSubscriptionPlansRequest) =>
		subscriptionPlanAdminClient.search(new SearchSubscriptionPlansRequest(request)),

	getById: (id: number) =>
		subscriptionPlanAdminClient.getById(id),

	create: (request: CreatePlanInput) =>
		subscriptionPlanAdminClient.create(
			new CreateSubscriptionPlanAdminRequest({
				...request,
				subscriptionPlanPaymentCycleType: SubscriptionPlanPaymentCycleTypes.OneTime,
				features: toFeatureInstances(request.features),
			})
		),

	update: (request: UpdatePlanInput) => {
		const updateRequest = new UpdateSubscriptionPlanAdminRequest({
			...request,
			subscriptionPlanPaymentCycleType: SubscriptionPlanPaymentCycleTypes.OneTime,
			features: toFeatureInstances(request.features),
		})
		updateRequest.id = request.id

		return subscriptionPlanAdminClient.update(updateRequest)
	},

	delete: (id: number) =>
		subscriptionPlanAdminClient.delete(id),

	activate: (id: number) =>
		subscriptionPlanAdminClient.activate(id),

	deactivate: (id: number) =>
		subscriptionPlanAdminClient.deactivate(id),
}
